import VfwChowCallHeroBanner from "../../assets/VFW Chow Call Hero Banner.png";

export const CHOW_CALL_EVENTS = {
  vfw981: {
    key: "chi26-chow-call-vfw981",
    slug: "chow-call-vfw981",
    path: "/chow-call-vfw981",
    aliases: ["/chow-call"],
    event_id: "chi26-chow-call-vfw981-2026-06-25",
    slotLabel: "Dinner Reservation",
    title: "Chow Call!",
    subtitle: "A Military Community Dinner",
    partnerName: "VFW Post 981",
    dateLabel: "June 25, 2026",
    timeLabel: "6:30 PM - 8:30 PM",
    venueName: "La Zingara Trattoria",
    addressLines: ["2300 E Rand Rd", "Arlington Heights, IL 60004"],
    webBanner: VfwChowCallHeroBanner,
    description:
      "Join the Road Home Program and VFW Post 981 for a complimentary dinner at La Zingara Trattoria. We’ll share a meal, build camaraderie, and connect veterans and service members with helpful resources.",
    audienceLabel: "Veterans / service members and 1 guest",
    mode: "family",
    limits: { maxPartySize: 2, capacityTotal: 20 },
    statusOptions: ["Veteran", "Active Duty", "Guard/Reserve"],
    defaultMailingListOptIn: true,
    mailingListInterests: ["Chow Call updates"],
    partySizeLabel: "Dinner reservation size*",
    partySizeHelp: "Veterans and service members may reserve up to 2 seats total, including 1 guest.",
  },
};
